import React, { useState, useEffect } from 'react';
import SideBar from '../../components/SideBar';
import TClasses from '../../components/Teacher/TClasses';
import { gradeApi } from '../../api.js';
import { FiMousePointer } from 'react-icons/fi';
import { useAuth } from '../../auth/AuthContext';

const TeacherClassesPage = () => {
  const [isApproved, setIsApproved] = useState(true);
  const [loading, setLoading] = useState(true);
  const { logout } = useAuth();

  useEffect(() => {
    const checkApprovalStatus = async () => {
      try {
        const response = await gradeApi.get({
          path: '/api/account/get-approval-status/',
          config: {}
        });
        setIsApproved(response.data.is_approved);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching approval status:', error);
        setLoading(false);
      }
    };

    checkApprovalStatus();
  }, []);

  const handleCalendlyClick = () => {
    window.open('https://calendly.com/maxbohun/gradewiz', '_blank');
  };

  const handleLogout = () => {
    logout();
  };

  if (loading) {
    return (
      <div className="w-full h-screen flex">
        <div id="Left-Sidebar" className="h-screen flex-shrink-0 w-side-bar-size">
          <SideBar activePage="Home" />
        </div>
        <div
          id="Right-content"
          className="flex-grow flex items-center justify-center overflow-y-auto h-screen"
        >
          <p className="text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  if (!isApproved) {
    return (
      <div className="w-full h-screen flex justify-center items-center bg-gray-50">
        <div className="w-full max-w-3xl mx-auto my-16 p-8 bg-white rounded-lg shadow-md relative">
          {/* Logout button at top right */}
          <button
            onClick={handleLogout}
            className="absolute top-4 right-4 px-3 py-1.5 text-sm text-gray-600 border border-gray-300 rounded-md hover:bg-gray-50 transition-all duration-300"
          >
            Log out
          </button>
          
          {/* Logo and Title */}
          <div className="text-center mb-8">
            <img src="/assets/logo_icon.png" alt="GradeWiz Logo" className="h-16 mx-auto mb-4" />
            <h2 className="text-2xl font-semibold text-gray-800 mb-3">
              Welcome to GradeWiz!
            </h2>
            <div className="w-24 h-1 mx-auto bg-gradient-to-r from-amber-400 to-amber-600 rounded"></div>
          </div>

          <div className="mb-8 text-left">
            <p className="text-gray-600 mb-4">
              Thank you for joining the GradeWiz community! We're excited to help you transform how you grade and manage your classes.
            </p>
            <p className="text-gray-600 mb-4">
              Your account is almost ready - we just need to give you a quick personal onboarding session with one of our founders.
              This helps ensure you get the most out of GradeWiz from day one.
            </p>
            <p className="text-gray-600 mb-4 font-medium">
              During this 15-minute meeting, we'll:
            </p>
            <ul className="list-disc pl-6 mb-4 text-gray-600 space-y-1">
              <li>Set up your first class</li>
              <li>Import your student roster</li>
              <li>Show you the fastest way to grade assignments</li>
              <li>Answer any questions you might have</li>
            </ul>
          </div>

          <div className="relative">
            <div className="w-full flex justify-center mb-8">
              <button
                type="button"
                className="w-3/4 flex justify-center py-3 px-6 border border-gray-300 text-sm font-medium rounded-md bg-white transition-all duration-300"
                style={{
                  color: '#4b5563',
                  boxShadow: '0 2px 6px rgba(0, 0, 0, 0.1)',
                  position: 'relative',
                  zIndex: 10
                }}
                onClick={handleCalendlyClick}
                onMouseEnter={e => {
                  e.currentTarget.style.transform = 'translateY(-2px)';
                  e.currentTarget.style.boxShadow = '0 4px 10px rgba(0, 0, 0, 0.15)';
                }}
                onMouseLeave={e => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 2px 6px rgba(0, 0, 0, 0.1)';
                }}
              >
                <span className="flex items-center">Schedule My Onboarding Session</span>
              </button>

              {/* Animated cursor effect */}
              <FiMousePointer
                className="absolute animate-bounce-slow"
                style={{
                  animation: 'bounce 2s infinite, glow 1.5s infinite alternate',
                  color: '#e4b17a',
                  fontSize: '1.5rem',
                  top: '50%',
                  right: '28%',
                  zIndex: 20
                }}
              />
            </div>
          </div>

          <style jsx>{`
            @keyframes bounce {
              0%,
              100% {
                transform: translateY(0);
              }
              50% {
                transform: translateY(-10px);
              }
            }

            @keyframes glow {
              0% {
                filter: drop-shadow(0 0 2px rgba(228, 177, 122, 0.7));
              }
              100% {
                filter: drop-shadow(0 0 8px rgba(228, 177, 122, 0.9));
              }
            }

            .animate-bounce-slow {
              animation: bounce 2s infinite;
            }
          `}</style>
        </div>
      </div>
    );
  }

  return (
    <div className="w-full h-screen flex">
      <div id="Left-Sidebar" className="h-screen flex-shrink-0 w-side-bar-size">
        <SideBar activePage="Home" />
      </div>
      <div id="Right-content" className="flex-grow overflow-y-auto h-screen">
        <TClasses />
      </div>
    </div>
  );
};

export default TeacherClassesPage;
